import React, { useEffect, useState } from "react";
import { Card, Button, CardContent, Grid, Typography, Box, Link, TextField } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from 'react-i18next';
import { AddIcon } from '@material-ui/data-grid';
import useStyles from "./ProviderDashboard.style";
import { Link as RouterLink } from 'react-router-dom';
import { RepLIProviderTextField } from '../../../components'
import SearchIcon from '@material-ui/icons/Search';
import TimelapseIcon from '@material-ui/icons/Timelapse';

import { buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import moment from "moment";
import validator from 'validator';
import Image0 from "../../../images/messaging.png";
import Image1 from "../../../images/providerDirectory.png";
import Image2 from "../../../images/viewUserProfiles.png";
import Image3 from "../../../images/userPortal.png";
import Image4 from "../../../images/website.png";
import Cookies from 'universal-cookie';
import { FormHelperText } from '@material-ui/core';


const cookies = new Cookies();

const ProviderDashboard = () => {

    const classes = useStyles();
    const { t } = useTranslation();

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [providerName, setProviderName] = useState('');
    const [overallPatientCount, setOverallPatientCount] = useState('');
    const [overallPatientPer, setOverallPatientPercent] = useState('');
    const [providerPatientCount, setProviderPatientCount] = useState('');
    const [providerPatientPer, setProviderPatientPercent] = useState('');
    const [patientRemovedCount, setPatientRemovedCount] = useState('');
    const [patientRemovedPer, setpatientRemovedPer] = useState('');
    const [updatePatientCount, setProfileUpdatedPatientCount] = useState('');
    const [updatePatientPer, setProfileUpdatedPatientPercent] = useState('');
    const [usersList, setUsersList] = useState([]);
    const [isSearchResultEmpty, setIsSearchResultEmpty] = useState(false);
    const [inputText, setInputText] = useState("");
    const [refreshKey, setRefreshKey] = useState(0);
    const [isFromDateValid, setFromDateValid] = useState(true);
    const [isFromDateError, setFromDateError] = useState(false);
    const [isToDateValid, setToDateValid] = useState(true);
    const [isToDateError, setToDateError] = useState(false);
    const [isComingSoon, setIsComingSoon] = useState(false);

    let inputHandler = (e) => {
        setUsersList([])
        setIsSearchResultEmpty(false);
        setInputText(e.target.value.trimStart());
    };


    let onSearchIconClick = async () => {
        setUsersList([])

        try {
            let response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER}/search/${inputText}`, {
                headers: {
                    'X-ACCESS-TOKEN': cookies.get('token')
                }
            });
            if (!response.ok) {
                return;
            };

            let result = await response.json();

            let patients = result.map(x => {
                return {
                    _id: x.user._id,
                    firstName: x.user.firstName,
                    lastName: x.user.lastName,
                    email: x.user.email,
                    dateOfBirth: (new Date(x.dateOfBirth)).toLocaleDateString()
                }
            });

            if (patients.length > 0) {
                setUsersList(patients)
            }
            else {
                setUsersList([])
                setIsSearchResultEmpty(true);
            }

        }
        catch (error) {
            console.log(error)
        }

    };

    const validateFromDate = (value) => {
        if (validator.isDate(value)) {
            if (toDate !== null) {
                if (new Date(value) <= new Date(toDate)) {
                    setFromDate(value);
                    setFromDateError(false);
                    setFromDateValid(true);
                    setToDateError(false);
                    setToDateValid(true);
                    setRefreshKey(oldKey => oldKey + 1);
                }
                else {
                    setFromDate(value);
                    setFromDateError(true);
                    setFromDateValid(true);
                }
            } else {
                setFromDate(value);
                setFromDateError(false);
                setFromDateValid(true);
            }
        } else {
            setFromDate(null);
            setFromDateError(false);
            setFromDateValid(false);
        }
    }


    const validateToDate = (value) => {
        if (validator.isDate(value)) {
            if (new Date(value) >= new Date(fromDate)) {
                setToDate(value);
                setToDateError(false);
                setToDateValid(true);
                setFromDateError(false);
                setFromDateValid(true);
                setRefreshKey(oldKey => oldKey + 1);
            }
            else {
                setToDate(null);
                setToDateError(true);
                setToDateValid(true);
            }
        } else {
            setToDate(null);
            setToDateError(false);
            setToDateValid(false);
        }
    }


    useEffect(() => {
        const getDashboardData = async () => {
            try {
                var date = new Date();
                var toDt = new Date();
                var fromDt = new Date(date.setMonth(date.getMonth() - 2));

                let response;

                if (toDate == "" && fromDate == "") {
                    setFromDate(moment(fromDt).utc().format('YYYY-MM-DD'));
                    setToDate(moment(toDt).utc().format('YYYY-MM-DD'));

                    response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_DASHBOARD}/${toDt}/${fromDt}`, {
                        headers: {
                            'X-ACCESS-TOKEN': cookies.get('token')
                        }
                    });
                }
                else {
                    response = await fetch(`${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_API_PROVIDER_DASHBOARD}/${toDate}/${fromDate}`, {
                        headers: {
                            'X-ACCESS-TOKEN': cookies.get('token')
                        }
                    });
                }

                let data = await response.json();
                data.message === 'Profile not found' ? setIsComingSoon(true) : setIsComingSoon(false);
                // if (!response.ok) {
                //     setError(t('module.provider.dashboard.message.providerDataLoadFailure'));
                //     return;
                // };  
                if (data.message !== 'jwt malformed' || data.message !== 'Invalid time value') {
                    setProviderName(data.providerName);
                    setOverallPatientCount(data.overallPatientCount);
                    setOverallPatientPercent(data.overallPatientPer);
                    setProviderPatientCount(data.providerPatientCount);
                    setProviderPatientPercent(data.providerPatientPer);
                    setProfileUpdatedPatientCount(data.updatePatientCount);
                    setProfileUpdatedPatientPercent(data.updatePatientPer);
                    setPatientRemovedCount(data.removedPatientCount);
                    setpatientRemovedPer(data.removedPatientPer);
                    setUsersList([])
                    setInputText("");
                }  


            } catch (error) {
                setIsComingSoon(true);
                console.log(error);
                // setError(`${t('module.provider.dashboard.message.dataLoadError')}. ${t('common.message.error.seeLog')}.`);
            } finally {
                setLoading(false);
            }
        };

        getDashboardData();
    }, [refreshKey]);

    if (error) return <Alert severity="error">{error}</Alert>

    return (
        <Box style={{ marginBottom: "20px" }}>
            {isComingSoon ?
                <Box>
                    <Typography>
                        <div style={{ display: "flex", justifyContent: "center" }}>
                            <TimelapseIcon className="in-progress-icon"></TimelapseIcon>
                            <div>Coming Soon</div>
                        </div>
                    </Typography>
                </Box>
                :
                <>
                    <Box style={{ paddingBottom: "30px" }} className={classes.container}>
                        <Typography className={classes.title}>
                            Dashboard
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            size="large"
                            className={classes.addButton}
                            component={RouterLink}
                            to="/provider/patient/add"
                            startIcon={<AddIcon />}
                        >
                            {t('common.form.button.createNewProfile')}
                        </Button>

                        <Box style={{ width: "35%" }}>
                            <TextField
                                className="inputRounded"
                                style={{ width: "100%" }}
                                value={inputText}
                                onChange={inputHandler}
                                variant="outlined"
                                placeholder="Search for patient"
                                size="large"
                                onKeyPress={(e) => {
                                    if (e.key === "Enter") {
                                        onSearchIconClick()
                                    }
                                }}
                                InputProps={{
                                    endAdornment: (
                                        <SearchIcon
                                            onClick={onSearchIconClick}
                                            style={{
                                                color: "rgb(31,161,157)",
                                                marginRight: "10px", cursor: "pointer"
                                            }} />
                                    )


                                }}
                            />
                            <Box style={{
                                position: "absolute",
                                backgroundColor: "#ffff",
                                color: "black",
                                zIndex: 1000,
                                minWidth: "28%",
                                maxWidth: "30%",

                            }}>
                                {usersList.map((user) => {

                                    return (
                                        <div className="customdropdown" style={{ margin: "5px", cursor: "pointer" }}>

                                            <Button style={{ textTransform: 'none' }}
                                                fullWidth
                                                component={RouterLink}
                                                to={`/provider/patient/profile/${user._id}`}>
                                                {user.firstName + " " + user.lastName + " " + user.dateOfBirth}
                                            </Button>
                                        </div>)
                                })}


                                {isSearchResultEmpty &&
                                    <div className="customdropdown" style={{ margin: "5px", cursor: "pointer" }}>

                                        <Button style={{ textTransform: 'none' }}
                                            fullWidth
                                        >
                                            No users found
                                        </Button>
                                    </div>

                                }
                            </Box>

                        </Box>

                    </Box>
                    <Card className={classes.panel}>
                        <CardContent className={classes.cardPaddStyle}>
                            <Grid container>
                                <Box style={{ width: "100%", backgroundColor: "#eff3f6" }}>
                                    <Box style={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center", padding: "10px 16px", height: "100px" }}>
                                        <Box style={{ width: "40%" }}>
                                            <Box style={{ display: "flex" }}>
                                                <Typography className={classes.userName}>
                                                    Patient Activity
                                                </Typography>
                                            </Box>
                                            <Box><Typography>{moment(fromDate).format("MMM DD, YYYY")} - {moment(toDate).format("MMM DD, YYYY")}</Typography></Box>
                                        </Box>
                                        <Box style={{ width: "60%", display: "flex", alignItems: "center" }}>
                                            <Box style={{ display: "flex", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
                                                <Box style={{ wordWrap: "break-word", width: "30%", justifyContent: "center" }}>
                                                    <Typography className={classes.userName}>
                                                        Period of time
                                                    </Typography>
                                                </Box>
                                                <Box style={{ width: "70%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                    <Box style={{ width: "40%" }}>
                                                        <RepLIProviderTextField
                                                            label={t('module.provider.dashboard.dateFilters.fromDate')}
                                                            type="date"
                                                            InputLabelProps={{ shrink: true }}
                                                            // error={props.submitted && !props.validator.fieldValid('fromDate')}
                                                            // helperText={props.validator.message('fromDate', props.fromDate, 'required')}
                                                            // onChange={e => setFromDate(e.target.value)}
                                                            onChange={(e) => validateFromDate(e.target.value)}
                                                            InputProps={{ inputProps: { max: moment(new Date()).format('YYYY-MM-DD') } }}
                                                            value={fromDate}
                                                            loading={loading}
                                                        />
                                                        {isFromDateError &&
                                                            <FormHelperText error>
                                                                {t('module.provider.dashboard.errorMessage.fromDate')}
                                                            </FormHelperText>
                                                        }
                                                        {!isFromDateValid &&
                                                            <FormHelperText error>
                                                                {t('module.provider.dashboard.errorMessage.fromDateReq')}
                                                            </FormHelperText>
                                                        }
                                                    </Box>
                                                    <Box style={{ wordWrap: "break-word", justifyContent: "center" }}>
                                                        <Typography >
                                                            to
                                                        </Typography>
                                                    </Box>
                                                    <Box style={{ width: "40%" }}>
                                                        <RepLIProviderTextField
                                                            label={t('module.provider.dashboard.dateFilters.toDate')}
                                                            type="date"
                                                            InputLabelProps={{ shrink: true }}
                                                            // error={props.submitted && !props.validator.fieldValid('dateOfBirth')}
                                                            // helperText={props.validator.message('dateOfBirth', props.dateOfBirth, 'required')}
                                                            // onChange={e => setToDate(e.target.value)}
                                                            onChange={(e) => validateToDate(e.target.value)}
                                                            InputProps={{ inputProps: { max: moment(new Date()).format('YYYY-MM-DD'), min: moment(fromDate).format('YYYY-MM-DD') } }}
                                                            value={toDate}
                                                            loading={loading}
                                                        />
                                                        {isToDateError &&
                                                            <FormHelperText error>
                                                                {t('module.provider.dashboard.errorMessage.toDate')}
                                                            </FormHelperText>
                                                        }
                                                        {!isToDateValid &&
                                                            <FormHelperText error>
                                                                {t('module.provider.dashboard.errorMessage.toDateReq')}
                                                            </FormHelperText>
                                                        }
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </Box>
                                </Box>
                                {/* <Box> */}
                                <Grid style={{ marginTop: "10px", padding: "16px" }} container>
                                    <Grid item style={{ display: "flex", justifyContent: "space-between", width: "100%" }} >
                                        <div style={{ width: "15%", flexDirection: "column" }}>
                                            <div style={{ textAlign: "center" }}>
                                                <CircularProgressbarWithChildren
                                                    value={overallPatientCount}
                                                    background
                                                    strokeWidth={3}
                                                    backgroundPadding={6}
                                                    styles={buildStyles({
                                                        backgroundColor: "#4A618A",
                                                        textColor: "#fff",
                                                        pathColor: "#fff",
                                                        trailColor: "transparent"
                                                    })}>
                                                    <div style={{ transform: "translate(-50%, -50%)", position: "absolute", top: "50%", left: "50%" }}>
                                                        <div style={{ whiteSpace: "break-spaces", marginTop: -5, color: "#fff", fontSize: "xx-large" }}>{overallPatientCount}</div>
                                                        <div style={{ whiteSpace: "break-spaces", marginTop: -5, color: "#fff", fontSize: "14px" }}>New users in your organization</div>
                                                    </div>
                                                </CircularProgressbarWithChildren>
                                            </div>
                                            <div style={{ textAlign: "center", marginTop: 5 }}>
                                                <span style={{ fontSize: "18px" }}>
                                                    {overallPatientPer==="NaN" ? 0 : overallPatientPer}% increase
                                                </span>
                                            </div>
                                        </div>
                                        <div style={{ flexDirection: "column", borderLeft: "5px solid #e0e5ec", height: "50%", alignSelf: "center" }}></div>
                                        <div style={{ width: "15%", flexDirection: "column" }}>
                                            <div style={{ textAlign: "center" }}>
                                                <CircularProgressbarWithChildren value={providerPatientCount} strokeWidth={3} styles={buildStyles({
                                                    pathColor: "#1fa19d"
                                                })}>
                                                    <div style={{ transform: "translate(-50%, -50%)", position: "absolute", top: "50%", left: "50%" }}>
                                                        <div style={{ marginTop: -5, fontSize: "40px" }}>
                                                            <strong>{providerPatientCount}</strong>
                                                        </div>
                                                        <div style={{ marginTop: -5, fontSize: "14px" }}>
                                                            <strong>New users assigned to you</strong>
                                                        </div>
                                                    </div>
                                                </CircularProgressbarWithChildren>
                                            </div>
                                            <div style={{ textAlign: "center", marginTop: 5 }}>
                                                <span style={{ fontSize: "18px" }}>
                                                    {providerPatientPer==="NaN" ? 0 :providerPatientPer}% increase
                                                </span>
                                            </div>
                                        </div>
                                        <div style={{ width: "15%", flexDirection: "column" }}>
                                            <div style={{ textAlign: "center" }}>
                                                <CircularProgressbarWithChildren value={updatePatientCount} strokeWidth={3} styles={buildStyles({
                                                    pathColor: "#1fa19d"
                                                })}>
                                                    <div style={{ transform: "translate(-50%, -50%)", position: "absolute", top: "50%", left: "50%" }}>
                                                        <div style={{ marginTop: -5, fontSize: 40 }}>
                                                            <strong>{updatePatientCount}</strong>
                                                        </div>
                                                        <div style={{ marginTop: -5, fontSize: "14px" }}>
                                                            <strong>Existing user profiles updated</strong>
                                                        </div>
                                                    </div>
                                                </CircularProgressbarWithChildren>
                                            </div>
                                            <div style={{ textAlign: "center", marginTop: 5 }}>
                                                <span style={{ fontSize: "18px" }}>
                                                    {updatePatientPer==="NaN" ? 0 : updatePatientPer}% increase
                                                </span>
                                            </div>
                                        </div>
                                        <div style={{ width: "15%", flexDirection: "column" }}>
                                            <div style={{ textAlign: "center" }}>
                                                <CircularProgressbarWithChildren value={patientRemovedCount} strokeWidth={3} styles={buildStyles({
                                                    pathColor: "#1fa19d"
                                                })}>
                                                    <div style={{ transform: "translate(-50%, -50%)", position: "absolute", top: "50%", left: "50%" }}>
                                                        <div style={{ marginTop: -5, fontSize: 40 }}><strong>{patientRemovedCount}</strong></div>
                                                        <div style={{ marginTop: -5, fontSize: "14px" }}>
                                                            <strong>Profiles removed</strong>
                                                        </div>
                                                    </div>
                                                </CircularProgressbarWithChildren>
                                            </div>
                                            <div style={{ textAlign: "center", marginTop: 5 }}>
                                                <span style={{ fontSize: "18px" }}>
                                                    {patientRemovedPer>100 ? 100 : patientRemovedPer}% increase
                                                </span>
                                            </div>
                                        </div>
                                        <div style={{ width: "15%", alignSelf: "end" }}>
                                            <div style={{ textAlign: "center" }}>
                                                <CircularProgressbarWithChildren value={5} strokeWidth={3} styles={buildStyles({
                                                    pathColor: "#1fa19d"
                                                })}>
                                                    <div style={{ transform: "translate(-50%, -50%)", position: "absolute", top: "50%", left: "50%" }}>
                                                        <div style={{ marginTop: -5, fontSize: 40 }}><strong>{5}</strong></div>
                                                        <div style={{ marginTop: -5, fontSize: "14px" }}>
                                                            <strong>Successful referrals made</strong>
                                                        </div>
                                                    </div>
                                                </CircularProgressbarWithChildren>
                                            </div>
                                            <div style={{ textAlign: "center", marginTop: 5 }}>
                                                <span style={{ fontSize: "18px" }}>
                                                    {30}% increase
                                                </span>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "16px" }} >
                                        <div style={{ width: "15%", flexDirection: "column" }}>
                                            <div style={{ textAlign: "center" }}>
                                                <Button fullWidth style={{ backgroundColor: "#eff3f6", borderRadius: "30px", cursor: "default" }}><b style={{ cursor: "text" }}>RepLI</b></Button>
                                            </div>
                                        </div>
                                        <div style={{ width: "75%", flexDirection: "column" }}>
                                            <div style={{ textAlign: "center" }}>
                                                <Button fullWidth style={{ backgroundColor: "#eff3f6", borderRadius: "30px", cursor: "default" }}><b style={{ cursor: "text" }}>{providerName}</b></Button>
                                            </div>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                    <Box className={classes.cardActionsStyle}>
                        <Card component={RouterLink} to="/provider/messaging" className={classes.cardStyle} style={{ width: "18%" }}>
                            <CardContent className={classes.cardPaddStyle}>
                                <img className={classes.card} src={Image0}></img>
                                <Typography>
                                    <strong style={{
                                        fontSize: "20px",
                                        position: "absolute",
                                        top: "65%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        whiteSpace: "nowrap"
                                    }}>Messaging</strong>
                                </Typography>
                            </CardContent>
                        </Card>
                        <Link component={RouterLink} to="/provider/provider/mypatients" style={{ width: "18%" }}>
                            <Card className={classes.cardStyle}>
                                <CardContent className={classes.cardPaddStyle}>
                                    <img className={classes.card} src={Image1}></img>
                                    <Typography>
                                        <strong style={{
                                            fontSize: "20px",
                                            position: "absolute",
                                            top: "65%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            whiteSpace: "nowrap"
                                        }}>Provider Directory</strong>
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Link>
                        <Link component={RouterLink} to="/provider/provider/mypatients" style={{ width: "18%" }}>
                            <Card className={classes.cardStyle}>
                                <CardContent className={classes.cardPaddStyle}>
                                    <img className={classes.card} src={Image2}></img>
                                    <Typography>
                                        <strong style={{
                                            fontSize: "20px",
                                            position: "absolute",
                                            top: "65%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            whiteSpace: "nowrap"
                                        }}>View User Profiles</strong>
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Link>
                        <Link component={RouterLink} to="/app" target="_blank" style={{ width: "18%" }}>
                            <Card className={classes.cardStyle}>
                                <CardContent className={classes.cardPaddStyle}>
                                    <img className={classes.card} src={Image3}></img>
                                    <Typography>
                                        <strong style={{
                                            fontSize: "20px",
                                            position: "absolute",
                                            top: "65%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            whiteSpace: "nowrap"
                                        }}>Go to User Portal</strong>
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Link>
                        <Link href="https://www.repli.online/" target="_blank" style={{ width: "18%" }}>
                            <Card className={classes.cardStyle}>
                                <CardContent className={classes.cardPaddStyle}>
                                    <img className={classes.card} src={Image4}></img>
                                    <Typography>
                                        <strong style={{
                                            fontSize: "20px",
                                            position: "absolute",
                                            top: "65%",
                                            left: "50%",
                                            transform: "translate(-50%, -50%)",
                                            whiteSpace: "nowrap"
                                        }}>Go to Website</strong>
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Link>
                    </Box>
                </>

            }
        </Box>
    )
};

export default ProviderDashboard;